export const API_ENDPOINT: string = 'https://api.exchangeratesapi.io';
